module.exports = __webpack_public_path__ + "img/image-10.02d35b09.webp";